import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.function.name.js";
var reportType = {
  LEGENDARY_DROP: 1,
  LEGENDARY_HERO_EXHIBITION: 2,
  LEGENDARY_EXTENSION_EXHIBITION: 3
};
export default {
  props: {
    reports: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    }
  },
  data: function data() {
    return {
      current: {}
    };
  },
  computed: {
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    hasCurrentReport: function hasCurrentReport() {
      return !!Object.keys(this.current).length;
    },
    filteredReports: function filteredReports() {
      return this.reports.filter(function (r) {
        return !r.read;
      });
    },
    moveTo: function moveTo() {
      switch (this.current.type) {
        case reportType.LEGENDARY_DROP:
          return this.localePath('quests');
        case reportType.LEGENDARY_HERO_EXHIBITION:
          return this.localePath('market-index-trade-index-heroes');
        case reportType.LEGENDARY_EXTENSION_EXHIBITION:
          return this.localePath('market-index-trade-index-extensions');
      }
    }
  },
  watch: {
    reports: function reports() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var sleep, _iterator, _step, report;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchData();
            case 2:
              sleep = function sleep(msec) {
                return new Promise(function (resolve) {
                  return setTimeout(resolve, msec);
                });
              };
              _iterator = _createForOfIteratorHelper(_this.filteredReports);
              _context.prev = 4;
              _iterator.s();
            case 6:
              if ((_step = _iterator.n()).done) {
                _context.next = 17;
                break;
              }
              report = _step.value;
              _this.current = report;
              _context.next = 11;
              return sleep(6000);
            case 11:
              useReportStore().setReadReport(report.reportId);
              _this.current = {};
              _context.next = 15;
              return sleep(1000);
            case 15:
              _context.next = 6;
              break;
            case 17:
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](4);
              _iterator.e(_context.t0);
            case 22:
              _context.prev = 22;
              _iterator.f();
              return _context.finish(22);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 19, 22, 25]]);
      }))();
    }
  },
  methods: {
    fetchHeroes: function fetchHeroes(ids) {
      return useHeroStore().fetchHeroes(ids);
    },
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    fetchData: function fetchData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var uids, heroIds, extensionIds;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              uids = _this2.filteredReports.map(function (r) {
                return Number(r.itemsList[0]);
              });
              heroIds = _this2.filteredReports.filter(function (r) {
                return r.type === reportType.LEGENDARY_HERO_EXHIBITION;
              }).map(function (r) {
                return Number(r.itemsList[1]);
              });
              extensionIds = _this2.filteredReports.filter(function (r) {
                return [reportType.LEGENDARY_DROP, reportType.LEGENDARY_EXTENSION_EXHIBITION].includes(r.type);
              }).map(function (r) {
                return Number(r.itemsList[1]);
              });
              _context2.next = 5;
              return Promise.all([useUserStore().fetchUsers(uids), _this2.fetchHeroes(heroIds), _this2.fetchExtensions(extensionIds)]);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getMessage: function getMessage(report) {
      var userName = "".concat((this.getUser(+report.itemsList[0]) || {}).name, "#").concat(+report.itemsList[0]);
      var at = this.$dayjs(report.at * 1000).format('LLLL');
      var data;
      switch (report.type) {
        case reportType.LEGENDARY_DROP:
        case reportType.LEGENDARY_EXTENSION_EXHIBITION:
          data = {
            userName: userName,
            extensionName: ((this.getExtension(+report.itemsList[1]) || {}).name || {})[this.$i18n.locale],
            at: at
          };
          break;
        case reportType.LEGENDARY_HERO_EXHIBITION:
          data = {
            userName: userName,
            heroName: ((this.getHero(+report.itemsList[1]) || {}).name || {})[this.$i18n.locale],
            at: at
          };
          break;
        default:
          data = {
            userName: userName,
            at: at
          };
      }
      return this.$t("reportTypes.".concat(report.type), data);
    }
  }
};